/// <amd-module name="Release/DeploymentsSection/DeploymentsSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IDeploymentsData } from "Release/DeploymentsSection/DeploymentsData";
import { IReleaseRestClient } from "Release/Client/RestClient/Release";
import { ReleaseEnvironment } from 'Release/Client/Contracts/Release';
import * as Resources from "Release/DeploymentsSection/Resources";

export class DeploymentsSource {
    constructor(
        private _pageContext: IVssPageContext
    ) {
    }

    public loadDeploymentsData(buildId: number): Promise<IDeploymentsData> {
        let contributionService = this._pageContext.getService<IVssContributionService>("IVssContributionService");
        let data = contributionService.getData<IDeploymentsData>("ms.vss-releaseManagement-web.build-summary-deployments-data-privateProvider");
        if (!data) {
            data = contributionService.getData<IDeploymentsData>("ms.vss-releaseManagement-web.build-summary-deployments-data-provider");
        }

        return new Promise(function (resolve, reject) {
            if (!data) {
                reject(Resources.DeploymentsNotFoundError);
            } else if (data.buildId === buildId.toString()) {
                resolve(data);
            } else {
                resolve({
                    autoTriggerIssues: [],
                    buildId: "",
                    favoriteDefinitionIds: [],
                    releases: []
                });
            }
        });
    }

    public getReleaseEnviroment(projectId: any, releaseId: any, environmentId: any): Promise<ReleaseEnvironment>{
        let deployServiceClient = this._pageContext.getRestClient<IReleaseRestClient>("IReleaseRestClient");
        return deployServiceClient.getReleaseEnvironment(projectId, releaseId, environmentId);
    }
}
